import { render, staticRenderFns } from "./zone-contact.vue?vue&type=template&id=5b4888d8&scoped=true"
import script from "./zone-contact.vue?vue&type=script&lang=js"
export * from "./zone-contact.vue?vue&type=script&lang=js"
import style0 from "./zone-contact.vue?vue&type=style&index=0&id=5b4888d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4888d8",
  null
  
)

export default component.exports